
import React from 'react';
import { PropertyField } from '../../molecules/PropertyField';
import { WorkflowNodeData } from '../../../types';

interface StartProcessTabProps {
    data: WorkflowNodeData;
    onChange: (key: string, value: any) => void;
}

export const StartProcessTab: React.FC<StartProcessTabProps> = ({ data, onChange }) => {
    return (
        <div className="p-6 space-y-4">
            <div className="p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-lg border border-emerald-100 dark:border-emerald-900">
                <p className="text-xs font-bold text-emerald-800 dark:text-emerald-300">Start Process Configuration</p>
                <p className="text-[11px] text-emerald-700 dark:text-emerald-400 mt-1">
                    Configure how the host initiates this workflow.
                </p>
            </div>

            <PropertyField
                config={{ name: 'startView', label: 'Start View', type: 'text', placeholder: 'Workflow::GenericStartView', description: 'UI component that renders the start form.' }}
                value={data.startView}
                onChange={onChange}
            />

            <div className="grid grid-cols-2 gap-4">
                <PropertyField
                    config={{ name: 'startRoles', label: 'Allowed Roles', type: 'text', placeholder: '* (all roles)', description: 'Comma-separated roles or * for all.' }}
                    value={data.startRoles}
                    onChange={onChange}
                />
                <PropertyField
                    config={{ name: 'startStep', label: 'Step', type: 'text', placeholder: '1' }}
                    value={data.startStep}
                    onChange={onChange}
                />
            </div>

            <div className="grid grid-cols-2 gap-4">
                <PropertyField
                    config={{ name: 'startMode', label: 'Mode', type: 'select', options: [{ value: 'end', label: 'End' }, { value: 'continue', label: 'Continue' }], defaultValue: 'end' }}
                    value={data.startMode}
                    onChange={onChange}
                />
                <PropertyField
                    config={{ name: 'startActorType', label: 'Actor Type', type: 'text', placeholder: 'Optional' }}
                    value={data.startActorType}
                    onChange={onChange}
                />
            </div>

            <PropertyField
                config={{ name: 'startDeduplication', label: 'Deduplication Key', type: 'text', placeholder: 'Leave empty for none', description: 'Prevents duplicate workflow instances.' }}
                value={data.startDeduplication}
                onChange={onChange}
            />

            <PropertyField
                config={{ name: 'startExtensions', label: 'Extensions (JSON)', type: 'object', rows: 4 }}
                value={data.startExtensions}
                onChange={onChange}
            />
        </div>
    );
};
